import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  GiftFragment,
  giftFragmentString,
} from '../../fragments/__generated__/GiftFragment'

import { priceString } from '../../fragments/__generated__/Price'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import getGiftsRawString from '../GetGifts.graphql'

const getGiftsString = [
  getGiftsRawString,
  giftFragmentString,
  priceString,
  giftVariationFragmentString,
  amountString,
].join('\n\n')

export type GetGiftsData = {
  gifts: GiftFragment[]
}

export type GetGiftsVariables = {
  category?: Maybe<string>
  offset: number
  limit: number
  search?: Maybe<string>
}

export type GetGifts = Operation<GetGiftsData, GetGiftsVariables>

export const GetGifts = ({
  category,
  offset,
  limit,
  search,
}: GetGiftsVariables): GetGifts => ({
  query: getGiftsString,
  variables: {
    category,
    offset,
    limit,
    search,
  },
})
